import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { useEffect, useRef, useState } from "react";
import { ILogin } from "../../models/Login";
import { IAllRequirements } from "../../models/AllRequirements";
import { Fetch } from "../../shared/Fetch";
import { format } from "date-fns";
import { Button } from "primereact/button";
import { Job_Type, Publish_Type, Req_Term } from "../../models/RequirementMast";

interface IFloatNotification {
    open?: boolean,
    onHide: () => void,
    toast?: any,
}

export const FloatNotification = (props: IFloatNotification) => {
    const [loading, setLoading] = useState<boolean>(false);

    const [floatTableData, setFloatTableData] = useState({} as { tableData: Array<IAllRequirements>, loading: boolean });
    const dt = useRef<any>();

    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const sendFloatEmail = async (req_ID: number) => {
        const response = await Fetch("Float/sendEmailForNoSubmissionsYet", "GET", null, `req_id=${req_ID}`, props.toast);
        if (response) {
            const resp: string = await response.text();
            props.toast.current.show({ severity: 'success', summary: 'success', detail: resp, life: 3000 });
            setLoading(false);
            loadFloatData();
        } else {
            setLoading(false);
        }
    };

    const actionFloat = (rowData: any) => {
        // let vizonFloat = false;
        // let adventaFloat = false;
        // let gvrFloat = false;
        // let jobvrittaFloat = false;

        // const postedDate = new Date(new Date(rowData.pDate || "").setMinutes(new Date(rowData.pDate || "").getMinutes() + 45));
        // const postedDate1 = new Date(new Date(rowData.pDate || "").setMinutes(new Date(rowData.pDate || "").getMinutes() + 0));

        // const current = new Date();
        // if (rowData.company_ID === 7 && postedDate <= current && rowData.is_Float_Global === false) {
        //     vizonFloat = true;
        // }
        // if (rowData.company_ID === 4 && postedDate <= current && rowData.is_Float_Global === false) {
        //     adventaFloat = true;
        // }
        // if (rowData.company_ID === 3 && postedDate <= current && rowData.is_Float_Global === false) {
        //     gvrFloat = true;
        // }
        // if (rowData.company_ID === 8 && postedDate1 <= current && rowData.is_Float_Global === false) {
        //     jobvrittaFloat = true;
        // }


        // if (vizonFloat === true) {
        //     return <Button loading={loading} className="p-button my-1 bg-blue-500" label={((rowData.is_Float_Global === null || rowData.is_Float_Global === false) ? ' Float' : 'Floated')} onClick={() => { if ((rowData.req_ID != null || rowData.req_ID != 0)) { sendFloatEmail(rowData.req_ID || 0); } setLoading(true); }} type="button"></Button>;
        //     // return (vizonFloat === true ? <Button loading={loading} className="p-button my-1 bg-blue-500 w-5" label={((rowData.is_Float_Company === null || rowData.is_Float_Company === false) ? ' Float' : 'Floated')} onClick={() => { if ((rowData.req_ID != null || rowData.req_ID != 0)) { sendFloatEmail(rowData.req_ID || 0); } setLoading(true); }} type="button"></Button> : <div style={{ display: 'grid', marginTop: '5px' }}>
        //     //     {(rowData.is_Float_Global === null || rowData.is_Float_Global === false) ? <Button loading={loading} className="p-button my-1 bg-blue-500" label={((rowData.is_Float_Global === null || rowData.is_Float_Global === false) ? ' Float' : 'Floated')} onClick={() => { if ((rowData.req_ID != null || rowData.req_ID != 0)) { sendFloatEmail(rowData.req_ID || 0); } setLoading(true); }} type="button"></Button> : "Floated"}
        //     // </div>);
        // } else if (adventaFloat === true) {
        //     return <Button loading={loading} className="p-button my-1 bg-blue-500" label={((rowData.is_Float_Global === null || rowData.is_Float_Global === false) ? ' Float' : 'Floated')} onClick={() => { if ((rowData.req_ID != null || rowData.req_ID != 0)) { sendFloatEmail(rowData.req_ID || 0); } setLoading(true); }} type="button"></Button>;
        //     // return (adventaFloat == true ? <Button loading={loading} className="p-button my-1 bg-blue-500 w-5" label={((rowData.is_Float_Company === null || rowData.is_Float_Company === false) ? ' Float' : 'Floated')} onClick={() => { if ((rowData.req_ID != null || rowData.req_ID != 0)) { sendFloatEmail(rowData.req_ID || 0); } setLoading(true); }} type="button"></Button> : <div style={{ display: 'grid', marginTop: '5px' }}>
        //     //     {(rowData.is_Float_Global === null || rowData.is_Float_Global === false) ? <Button loading={loading} className="p-button my-1 bg-blue-500" label={((rowData.is_Float_Global === null || rowData.is_Float_Global === false) ? ' Float' : 'Floated')} onClick={() => { if ((rowData.req_ID != null || rowData.req_ID != 0)) { sendFloatEmail(rowData.req_ID || 0); } setLoading(true); }} type="button"></Button> : "Floated"}

        //     // </div>);
        // } else if (gvrFloat === true) {
        //     return <Button loading={loading} className="p-button my-1 bg-blue-500" label={((rowData.is_Float_Global === null || rowData.is_Float_Global === false) ? ' Float' : 'Floated')} onClick={() => { if ((rowData.req_ID != null || rowData.req_ID != 0)) { sendFloatEmail(rowData.req_ID || 0); } setLoading(true); }} type="button"></Button>;
        //     // return (gvrFloat == true ? <Button loading={loading} className="p-button my-1 bg-blue-500 w-5" label={((rowData.is_Float_Company === null || rowData.is_Float_Company === false) ? ' Float' : 'Floated')} onClick={() => { if ((rowData.req_ID != null || rowData.req_ID != 0)) { sendFloatEmail(rowData.req_ID || 0); } setLoading(true); }} type="button"></Button> : <div style={{ display: 'grid', marginTop: '5px' }}>
        //     //     {(rowData.is_Float_Global === null || rowData.is_Float_Global === false) ? <Button loading={loading} className="p-button my-1 bg-blue-500" label={((rowData.is_Float_Global === null || rowData.is_Float_Global === false) ? ' Float' : 'Floated')} onClick={() => { if ((rowData.req_ID != null || rowData.req_ID != 0)) { sendFloatEmail(rowData.req_ID || 0); } setLoading(true); }} type="button"></Button> : "Floated"}

        //     // </div>);
        // } 
        // else if (jobvrittaFloat === true) {
        //     return <Button loading={loading} className="p-button my-1 bg-blue-500" label={((rowData.is_Float_Global === null || rowData.is_Float_Global === false) ? ' Float' : 'Floated')} onClick={() => { if ((rowData.req_ID != null || rowData.req_ID != 0)) { sendFloatEmail(rowData.req_ID || 0); } setLoading(true); }} type="button"></Button>;
        //     // return (gvrFloat == true ? <Button loading={loading} className="p-button my-1 bg-blue-500 w-5" label={((rowData.is_Float_Company === null || rowData.is_Float_Company === false) ? ' Float' : 'Floated')} onClick={() => { if ((rowData.req_ID != null || rowData.req_ID != 0)) { sendFloatEmail(rowData.req_ID || 0); } setLoading(true); }} type="button"></Button> : <div style={{ display: 'grid', marginTop: '5px' }}>
        //     //     {(rowData.is_Float_Global === null || rowData.is_Float_Global === false) ? <Button loading={loading} className="p-button my-1 bg-blue-500" label={((rowData.is_Float_Global === null || rowData.is_Float_Global === false) ? ' Float' : 'Floated')} onClick={() => { if ((rowData.req_ID != null || rowData.req_ID != 0)) { sendFloatEmail(rowData.req_ID || 0); } setLoading(true); }} type="button"></Button> : "Floated"}

        //     // </div>);
        // }
        // else {
        return (rowData.publish_Type !== Publish_Type.Company && rowData.publish_Type !== Publish_Type.Globally) ? (
            <Button loading={loading} className="p-button my-1 bg-blue-500"
                label='Float' onClick={() => { if (rowData.req_ID != null && rowData.req_ID != 0) { sendFloatEmail(rowData.req_ID); } setLoading(true); }} type="button" />
        ) : ("Floated");
        // };
    };

    const loadFloatData = async () => {
        setFloatTableData({ tableData: floatTableData.tableData, loading: true });
        const response = await Fetch("Float", "GET", null, null, props.toast);
        if (response) {
            const data: Array<IAllRequirements> = await response.json() || [];
            setFloatTableData({ tableData: data, loading: false });
        } else setFloatTableData({ tableData: floatTableData.tableData, loading: false });
    }

    useEffect(() => {
        if (props.open) loadFloatData();
    }, [props.open]);

    return (
        <>
            <Dialog visible={props.open} style={{ width: '80vw' }} header="Float Requirement" modal className="p-fluid" onHide={props.onHide}>
                {(_roles.includes(1) || _roles.includes(2) || _roles.includes(5) || _roles.includes(26)) && <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                    ref={dt} size="small" stripedRows showGridlines responsiveLayout="scroll"
                    resizableColumns columnResizeMode="expand"
                    scrollable scrollHeight="30vh"
                    value={floatTableData.tableData}
                    emptyMessage="No Requirements found."
                    header={''}
                    loading={floatTableData.loading}
                >
                    <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                    <Column field="req_ID" header="Req.ID" sortable />
                    <Column field="req_Job_Title" sortable header="Job Title" />
                    <Column field="req_Duration" header="Duration" />
                    <Column field="location" header="Location" />
                    <Column field="req_CategoryName" header="Category" sortable />
                    <Column field="req_Term" header="Job Term" body={(rowData: IAllRequirements) => rowData.req_Term ? Req_Term[rowData.req_Term] : ""} />
                    <Column field="job_Type" header="Job Type" body={(rowData: IAllRequirements) => rowData.job_Type ? Job_Type[rowData.job_Type] : ""} />
                    <Column field="pDate" header="Posted On" body={(e) => <p>{format(new Date(e.pDate), 'dd/MM/yyyy').toUpperCase()}</p>} />
                    <Column field="user_Name" sortable header="Sales Manager" />
                    <Column field="recruiter" header="Recruiter" />
                    <Column field="req_EndClient" sortable header="End Client" />
                    <Column field="client_Communication" sortable header="Client Communication" />
                    <Column header="Action" body={actionFloat} style={{ minWidth: '12rem' }} />
                </DataTable>}
            </Dialog>
        </>
    );
}